module.exports = __webpack_public_path__ + "static/media/57.3969aeaa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/57.svg
// module id = 162
// module chunks = 0